import { render, staticRenderFns } from "./MultiSelectJournal.vue?vue&type=template&id=22885f12"
import script from "./MultiSelectJournal.vue?vue&type=script&lang=ts"
export * from "./MultiSelectJournal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22885f12')) {
      api.createRecord('22885f12', component.options)
    } else {
      api.reload('22885f12', component.options)
    }
    module.hot.accept("./MultiSelectJournal.vue?vue&type=template&id=22885f12", function () {
      api.rerender('22885f12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiSelectJournal.vue"
export default component.exports